import React from 'react';
import { ChevronLeft } from 'lucide-react';
import InfoCardStackList from '../../components/InfoCardStackList';
import { useTranslate } from '../../lib/i18n';
import { InfoCardStack } from '../../types/cards.types';

interface Props {
  topic: string;
  onClose: () => void;
  topicStacks?: InfoCardStack[] | undefined;
}

const SelectedCards = ({ topic, onClose, topicStacks }: Props) => {
  const t = useTranslate();

  return (
    <div className="relative overflow-hidden">
      <div className="foo">
        <h3 className="mb-6 text-center text-xl font-bold text-card-foreground">
          {t('topics.' + topic)}
        </h3>
        <div className="flex flex-col items-center gap-4">
          <button
            onClick={onClose}
            className="mb-4 flex items-center self-start text-card-foreground hover:underline"
          >
            <ChevronLeft className="mr-2 h-4 w-4" /> {t('otherTopic.backToTopics')}
          </button>
          <div className="w-full max-w-[500px] px-6">
            {topicStacks && <InfoCardStackList stacks={topicStacks} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedCards;
